import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const WelcomeCardDipendente = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ fullName: '', azienda: '', loading: true });

  useEffect(() => {
    const getData = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profil } = await supabase
          .from('profili')
          .select('nome, cognome, aziende(nome_azienda)')
          .eq('id', user.id)
          .single();

        if (profil) {
          setData({
            fullName: `${profil.nome} ${profil.cognome}`,
            azienda: profil.aziende?.nome_azienda || 'OrizonDesk',
            loading: false
          });
        }
      }
    };
    getData();
  }, []);

  // Logika za pozdrav na osnovu vremena i prevoda
  const currentHour = new Date().getHours();
  let greetingKey = 'dipendente.welcome_card_dipendente.morning_dipendente';
  if (currentHour >= 12 && currentHour < 18) greetingKey = 'dipendente.welcome_card_dipendente.afternoon_dipendente';
  if (currentHour >= 18) greetingKey = 'dipendente.welcome_card_dipendente.evening_dipendente';

  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-2xl p-8 text-white shadow-lg">
      <div className="flex justify-between items-start">
        <div>
          <span className="bg-white/20 px-3 py-1 rounded-full text-xs uppercase tracking-widest">
            {data.loading ? t('dipendente.welcome_card_dipendente.loading_dipendente') : data.azienda}
          </span>
          <h1 className="text-3xl font-bold mt-4">
            {data.loading 
              ? t('dipendente.welcome_card_dipendente.loading_dipendente') 
              : `${t(greetingKey)}, ${data.fullName}!`}
          </h1>
          <p className="mt-2 opacity-80">
            {t('dipendente.welcome_card_dipendente.subtitle_dipendente', { azienda: data.azienda })}
          </p>
        </div>
        <Icon name="Sparkles" size={48} className="opacity-20" />
      </div>
    </div>
  );
};

export default WelcomeCardDipendente;